import { useEffect, useState, useCallback } from "react";
import { openDB } from "idb";
import type { UploadFile } from "antd/es/upload/interface";

async function getDB() {
  return openDB("upload-files-db", 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("files")) {
        db.createObjectStore("files", { keyPath: "uid" });
      }
    },
  });
}

export function useIndexedDBFileList(initialValue: UploadFile[] = []) {
  const [fileList, setFileList] = useState<UploadFile[]>(initialValue);
  useEffect(() => {
    (async () => {
      const db = await getDB();
      const allFiles = await db.getAll("files");
      if (allFiles.length > 0) {
        setFileList(allFiles as UploadFile[]);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const db = await getDB();
      const tx = db.transaction("files", "readwrite");
      const store = tx.objectStore("files");
      await store.clear();
      for (const file of fileList) {
        await store.put(file);
      }
      await tx.done;
    })();
  }, [fileList]);

  const clearFileList = useCallback(async () => {
    const db = await getDB();
    const tx = db.transaction("files", "readwrite");
    await tx.objectStore("files").clear();
    await tx.done;
    setFileList([]);
  }, []);

  return [fileList, setFileList, clearFileList] as const;
}
